export default __webpack_public_path__ + "media/color/bnt-bbf03108.svg";